import { render, staticRenderFns } from "./InformeCostoIndex.vue?vue&type=template&id=51259e5c"
import script from "./InformeCostoIndex.vue?vue&type=script&lang=js"
export * from "./InformeCostoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports